import { CancelToken } from 'axios';
import { axios } from './axios';
import { handleErrors } from './utils';

/**
 * @param {object} [requestOptions]
 * @param {Record<string, string | number | boolean>} [requestOptions.headers] — e.g. list pagination (`count`, `offset`)
 */
export function get(entity, params = {}, requestOptions = {}) {
    if (!entity) return Promise.reject('Entity is needed');
    const { headers: requestHeaders } = requestOptions;
    // there is a problem when we cancel the request but the
    // request is because we need another page for the table
    // if (entityListTokenCancel) {
    //     entityListTokenCancel('cancel');
    // }
    return new Promise((resolve, reject) => {
        axios
            .get(entity.endpoint, {
                params,
                cancelToken: new CancelToken(() => {}),
                ...(requestHeaders ? { headers: requestHeaders } : {}),
            })
            .then(({ data }) => {
                resolve(data);
            })
            .catch(handleErrors(reject));
    });
}
